import { call, put, takeLatest } from "redux-saga/effects";

import {
  getContractOverviewSuccess,
  getContractOverviewFailure,
  getContractCodeSuccess,
  getContractCodeFailure,
} from "./ContractInfo.actions";
import { ContractOverviewService } from "./ContractOverview.store";
import { ContractCodeService } from "./ContractCode.store";

function* getContractOverviewSaga(args) {
  try {
    const contractOverviewService = new ContractOverviewService();
    const { overview } = yield call(
      contractOverviewService.fetchContractOverview,
      args
    );
    yield put(getContractOverviewSuccess(overview));
  } catch (error) {
    yield put(getContractOverviewFailure(error));
  }
}

function* getContractCodeSaga(args) {
  try {
    const contractCodeService = new ContractCodeService();
    const { code } = yield call(contractCodeService.fetchContractCode, args);
    yield put(getContractCodeSuccess(code));
  } catch (error) {
    yield put(getContractCodeFailure(error));
  }
}

export function* contractInfoSagas() {
  const GET_CONTRACTOVERVIEW = "GET_CONTRACTOVERVIEW";
  yield takeLatest(GET_CONTRACTOVERVIEW, getContractOverviewSaga);
  const GET_CONTRACTCODE = "GET_CONTRACTCODE";
  yield takeLatest(GET_CONTRACTCODE, getContractCodeSaga);
}
